/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PlayerStatBestHandWonModel, PlayerStatBestHandWonModelType } from './PlayerStatBestHandWonModel'
import { PlayerStatBestHandWonModelSelector } from './PlayerStatBestHandWonModel.base'
import { PlayerStatBiggestWinModel, PlayerStatBiggestWinModelType } from './PlayerStatBiggestWinModel'
import { PlayerStatBiggestWinModelSelector } from './PlayerStatBiggestWinModel.base'
import { RootStoreType } from './index'

/**
 * AggregatedPlayerStatsBase
 * auto generated base class for the model AggregatedPlayerStatsModel.
 */
export const AggregatedPlayerStatsModelBase = ModelBase.named('AggregatedPlayerStats')
  .props({
    __typename: types.optional(types.literal('AggregatedPlayerStats'), 'AggregatedPlayerStats'),
    allTimeBestHandWon: types.union(
      types.undefined,
      types.null,
      types.late(() => PlayerStatBestHandWonModel)
    ),
    allTimeBiggestWin: types.union(
      types.undefined,
      types.null,
      types.late(() => PlayerStatBiggestWinModel)
    ),
    numberOfHands: types.union(types.undefined, types.number),
    numberOfHandsPlayed: types.union(types.undefined, types.number),
    numberOfHandsWon: types.union(types.undefined, types.number),
    preflopFold: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AggregatedPlayerStatsModelSelector extends QueryBuilder {
  get numberOfHands() {
    return this.__attr('numberOfHands')
  }
  get numberOfHandsPlayed() {
    return this.__attr('numberOfHandsPlayed')
  }
  get numberOfHandsWon() {
    return this.__attr('numberOfHandsWon')
  }
  get preflopFold() {
    return this.__attr('preflopFold')
  }
  allTimeBestHandWon(
    builder:
      | string
      | PlayerStatBestHandWonModelSelector
      | ((selector: PlayerStatBestHandWonModelSelector) => PlayerStatBestHandWonModelSelector)
      | undefined
  ) {
    return this.__child('allTimeBestHandWon', PlayerStatBestHandWonModelSelector, builder)
  }
  allTimeBiggestWin(
    builder:
      | string
      | PlayerStatBiggestWinModelSelector
      | ((selector: PlayerStatBiggestWinModelSelector) => PlayerStatBiggestWinModelSelector)
      | undefined
  ) {
    return this.__child('allTimeBiggestWin', PlayerStatBiggestWinModelSelector, builder)
  }
}
export function selectFromAggregatedPlayerStats() {
  return new AggregatedPlayerStatsModelSelector()
}

export const aggregatedPlayerStatsModelPrimitives =
  selectFromAggregatedPlayerStats().numberOfHands.numberOfHandsPlayed.numberOfHandsWon.preflopFold
